import axios from 'axios';

import { getObjOnLocalStorage } from 'utils/functions';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import {
	return_REACT_APP_AUTH_HOST,
	return_REACT_APP_CMS_GRAPHQL_HOST,
	return_REACT_APP_CMS_HOST
} from 'utils/env';

// Caso tenha alguma configuração de Headers e etc, coloque aqui
// export const headers = {
// 	language: 'pt'
// };

// Requisições do sistema são feitas por essas constante
export const apiAxiosCMS = axios.create({
	baseURL: return_REACT_APP_CMS_HOST()
	// headers: headers
});

// Adiciona um interceptor para inserir o token automaticamente
apiAxiosCMS.interceptors.request.use(
	(config) => {
		// Buscar o token salvo no LocalStorage
		const tokens = getObjOnLocalStorage('tokensMondelez');
		// Verifica se há um token válido antes de adicionar ao header
		if (tokens && tokens.access_token) {
			config.headers.Authorization = `Bearer ${tokens.access_token}`;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Requisições do sistema são feitas por essas constante
export const apiAxiosAuth = axios.create({
	baseURL: return_REACT_APP_AUTH_HOST(),
	headers: {
		'x-api-key':
			'tx5GwxqLaMZKQsRrHaTeA9VumslvDv3XAnwiWl8Zoswwf08W0HKqG2yrHbB9YXzE'
	}
});

// Adiciona um interceptor para inserir o token automaticamente
apiAxiosAuth.interceptors.request.use(
	(config) => {
		// Buscar o token salvo no LocalStorage
		const tokens = getObjOnLocalStorage('tokensMondelez');
		// Verifica se há um token válido antes de adicionar ao header
		if (tokens && tokens.access_token) {
			config.headers.Authorization = `Bearer ${tokens.access_token}`;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export const graphql = new ApolloClient({
	uri: return_REACT_APP_CMS_GRAPHQL_HOST() || 'http://localhost:3333/graphql', // 'http://23.22.89.145:87',
	cache: new InMemoryCache(),
	headers: {
		'x-tenant-id': process.env.REACT_APP_TENANT_ID || ''
	}
});
